<template>
  <nuxt-link
    :data-type="`city-${item.id}`"
    :to="{
      name: 'search-type',
      params: {
        type: $t('router.search_type.type.city'),
        value: item.slug,
        tab: $t('router.search_type.tab.tours'),
      },
    }"
  >
    <span class="item-search-title">{{ item.name }}</span>
    <template v-if="hasDescription">
      <br /><span class="item-search-description">{{ item.description }}</span>
    </template>
  </nuxt-link>
</template>

<script>
import LadSearchCommon from './common'

export default {
  name: 'LadSearchCity',
  extends: LadSearchCommon,
  computed: {
    hasDescription() {
      return (this.item.description || '').split(' ').length > 2
    },
  },
}
</script>
